import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ReactLenis } from "lenis/react";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { AuthDialog } from "@/components/AuthDialog";
import { Nav } from "@/components/Nav";
import { Hero } from "@/components/Hero";
import { MarqueeStrip } from "@/components/MarqueeStrip";
import { Manifesto } from "@/components/Manifesto";
import { CalendarSection } from "@/components/CalendarSection";
import { Bears } from "@/components/Bears";
import { Ball } from "@/components/Ball";
import { VideoShowcase } from "@/components/VideoShowcase";
import { MomentsGallery } from "@/components/MomentsGallery";
import { JoinSection } from "@/components/JoinSection";
import { Footer } from "@/components/Footer";
import PaymentResult from "@/pages/PaymentResult";
import AdminDashboard from "@/pages/AdminDashboard";
import { Sparkles } from "@/components/Sparkles";

function Landing() {
  return (
    <div className="bg-transparent text-[#33240E]">
      <Nav />
      <Hero />
      <MarqueeStrip />
      <Manifesto />
      <CalendarSection />
      <Bears />
      <JoinSection />
      <Ball />
      <VideoShowcase />
      <MomentsGallery />
      <Footer />
    </div>
  );
}

function App() {
  return (
    <ReactLenis root options={{ lerp: 0.08 }}>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/payment/success" element={<PaymentResult mode="success" />} />
            <Route path="/payment/cancel" element={<PaymentResult mode="cancel" />} />
            <Route path="/admin" element={<AdminDashboard />} />
          </Routes>
        </BrowserRouter>
        <AuthDialog />
        <Sparkles />
        <Toaster theme="dark" position="bottom-center" toastOptions={{ style: { background: "#FFF9EA", border: "1px solid #2A2A2A", color: "#33240E" } }} />
        <div className="grain-overlay" />
      </AuthProvider>
    </ReactLenis>
  );
}

export default App;
